module.exports = __webpack_public_path__ + "static/media/draw.57751c81.mp3";